import { SitNGoSummary } from '@app/models/sit-n-go-summary';
import { createAction, props } from '@ngrx/store';

export const updateLoader = createAction('[Sit N Go Summaries] Update Loader', props<{ loader: boolean }>());
export const updateAll = createAction('[Sit N Go Summaries] Update Sit N Go Summaries', props<{ sitNGoSummaries: SitNGoSummary[] }>());
export const updateOne = createAction('[Sit N Go Summaries] Update Sit N Go Summary', props<{ sitNGoSummary: SitNGoSummary }>());
